module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Vector_C.4d0ac3db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Vector_C.png
// module id = 421
// module chunks = 0